import { protectedLoader } from './protectLoader'
import { LoaderFunctionArgs } from 'react-router-dom'
import {
  CUSTOMER_ADMIN,
  CUSTOMER_SUPPORT,
  DISTRIBUTOR_ADMIN,
  DISTRIBUTOR_SUPPORT,
  HOLDER,
  PORTAL_ADMIN,
  PORTAL_SUPPORT,
} from '.'
import { lazyRoute } from '../utils/lazyRoute'

const licenseRoutes = [
  {
    path: '/licenses/:installKey?',
    lazy: lazyRoute(() => import('../pages/Portal/Licenses/LicensesScreen')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
        ],
      }),
  },
  {
    path: '/my-licenses',
    lazy: lazyRoute(
      () => import('../pages/Portal/Licenses/MyLicenses'),
      'MyLicenses',
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [HOLDER],
      }),
  },
]

export default licenseRoutes
